<section class="org-settings glass-panel">
  <p class="eyebrow">{{ 'ORG_SETTINGS.EYEBROW' | translate }}</p>
  <h1>{{ 'ORG_SETTINGS.TITLE' | translate }}</h1>
  <p class="lede">{{ 'ORG_SETTINGS.LEDE' | translate }}</p>

  @if (!canManage()) {
    <p class="org-settings__hint" role="status">{{ 'COMMON.READONLY_NO_PERMISSION' | translate }}</p>
  }

  @if (pageLoading()) {
    <p class="org-settings__status" role="status">{{ 'ORG_SETTINGS.LOADING' | translate }}</p>
  }

  @if (pageError(); as pe) {
    <p class="org-settings__error" role="alert">{{ pe }}</p>
  }

  @if (!pageLoading() && !pageError()) {
    <form class="org-settings__form" [formGroup]="form" (ngSubmit)="saveOperational()" novalidate>
      <div formGroupName="attendance">
      <fieldset class="org-settings__fieldset" [disabled]="!canManage()">
        <legend>{{ 'ORG_SETTINGS.SECTION_ATTENDANCE_POLICY' | translate }}</legend>
        <div class="org-settings__row-inner" formGroupName="policy">
          <label class="field">
            <span class="field__label">{{ 'ORG_SETTINGS.LATE_GRACE_MINUTES' | translate }}</span>
            <input class="field__input" type="number" formControlName="lateGraceMinutes" />
          </label>
          <label class="field">
            <span class="field__label">{{ 'ORG_SETTINGS.EARLY_LEAVE_GRACE_MINUTES' | translate }}</span>
            <input class="field__input" type="number" formControlName="earlyLeaveGraceMinutes" />
          </label>
          <label class="field">
            <span class="field__label">
              {{ 'ORG_SETTINGS.EARLIEST_CHECK_IN_MINUTES' | translate }}
              <span
                class="field__help"
                tabindex="0"
                [pTooltip]="'ORG_SETTINGS.EARLIEST_CHECK_IN_MINUTES_HINT' | translate"
                tooltipPosition="top"
                [attr.aria-label]="'ORG_SETTINGS.EARLIEST_CHECK_IN_MINUTES_HINT' | translate"
              >
                <i class="pi pi-info-circle" aria-hidden="true"></i>
              </span>
            </span>
            <input class="field__input" type="number" min="0" max="1440" step="1" formControlName="earliestCheckInMinutesBeforeShift" />
            @if (earliestCheckInInvalid()) {
              <span class="field__error" role="alert">{{ 'ORG_SETTINGS.EARLIEST_CHECK_IN_MINUTES_INVALID' | translate }}</span>
            }
          </label>
          <label class="field">
            <span class="field__label">
              {{ 'ORG_SETTINGS.HALF_DAY_MIN_WORKED_HOURS' | translate }}
              <span
                class="field__help"
                tabindex="0"
                [pTooltip]="'ORG_SETTINGS.WORKED_HOURS_HINT' | translate"
                tooltipPosition="top"
                [attr.aria-label]="'ORG_SETTINGS.WORKED_HOURS_HINT' | translate"
              >
                <i class="pi pi-info-circle" aria-hidden="true"></i>
              </span>
            </span>
            <input
              class="field__input"
              type="number"
              min="0.25"
              max="24"
              step="0.25"
              formControlName="halfDayMinWorkedHours"
            />
            <span class="field__hint">{{ 'ORG_SETTINGS.WORKED_HOURS_FALLBACK' | translate: { percent: halfDayFallbackPercent() } }}</span>
            @if (attendanceHoursInvalid('halfDayMinWorkedHours')) {
              <span class="field__error" role="alert">{{ 'ORG_SETTINGS.ATTENDANCE_HOURS_INVALID' | translate }}</span>
            }
          </label>
          <label class="field">
            <span class="field__label">
              {{ 'ORG_SETTINGS.WORKDAY_MIN_WORKED_HOURS' | translate }}
              <span
                class="field__help"
                tabindex="0"
                [pTooltip]="'ORG_SETTINGS.WORKED_HOURS_HINT' | translate"
                tooltipPosition="top"
                [attr.aria-label]="'ORG_SETTINGS.WORKED_HOURS_HINT' | translate"
              >
                <i class="pi pi-info-circle" aria-hidden="true"></i>
              </span>
            </span>
            <input
              class="field__input"
              type="number"
              min="0.25"
              max="24"
              step="0.25"
              formControlName="workdayMinWorkedHours"
            />
            <span class="field__hint">{{ 'ORG_SETTINGS.WORKED_HOURS_FALLBACK' | translate: { percent: workdayFallbackPercent() } }}</span>
            @if (attendanceHoursInvalid('workdayMinWorkedHours')) {
              <span class="field__error" role="alert">{{ 'ORG_SETTINGS.ATTENDANCE_HOURS_INVALID' | translate }}</span>
            }
          </label>
          @if (attendanceHoursOrderInvalid()) {
            <p class="field__error org-settings__field-error" role="alert">{{ 'ORG_SETTINGS.ATTENDANCE_HOURS_ORDER_INVALID' | translate }}</p>
          }
          <label class="field">
            <span class="field__label">{{ 'ORG_SETTINGS.ABSENT_CHECK_IN_AFTER_RATIO' | translate }}</span>
            <select class="field__input" formControlName="absentCheckInAfterRatio">
              @for (option of ratioOptions('absentCheckInAfterRatio'); track option.value) {
                <option [ngValue]="option.value">{{ numericOptionLabel(option) }}</option>
              }
            </select>
          </label>
          @if (attendancePolicyRatioInvalid()) {
            <p class="field__error org-settings__field-error" role="alert">{{ 'ORG_SETTINGS.ATTENDANCE_RATIO_INVALID' | translate }}</p>
          }
        </div>
      </fieldset>

      <fieldset class="org-settings__fieldset" [disabled]="!canManage()">
        <legend>{{ 'ORG_SETTINGS.SECTION_GEOFENCE_FACE' | translate }}</legend>
        <div class="org-settings__row-inner" formGroupName="geofence">
          <label class="field org-settings__check">
            <input type="checkbox" [checked]="outsideGeofenceAllowed()" (change)="onOutsideGeofenceToggle($event)" />
            <span>{{ 'ORG_SETTINGS.OUTSIDE_GEOFENCE_ALLOWED' | translate }}</span>
          </label>
          @if (outsideGeofenceAllowed()) {
            <label class="field">
              <span class="field__label">{{ 'ORG_SETTINGS.OUTSIDE_GRACE_MINUTES' | translate }}</span>
              <input class="field__input" type="number" min="1" formControlName="outsideGraceMinutes" />
            </label>
          }
        </div>
        <div class="org-settings__row-inner" formGroupName="faceRecognition">
          <label class="field">
            <span class="field__label">
              {{ 'ORG_SETTINGS.FACE_MIN_COSINE' | translate }}
              <span
                class="field__help"
                tabindex="0"
                [pTooltip]="'ORG_SETTINGS.FACE_MIN_COSINE_HINT' | translate"
                tooltipPosition="top"
                [attr.aria-label]="'ORG_SETTINGS.FACE_MIN_COSINE_HINT' | translate"
              >
                <i class="pi pi-info-circle" aria-hidden="true"></i>
              </span>
            </span>
            <select class="field__input" formControlName="minCosineSimilarity">
              @for (option of faceAccuracyOptions(); track option.value) {
                <option [ngValue]="option.value">{{ numericOptionLabel(option) }}</option>
              }
            </select>
          </label>
          <label class="field org-settings__check">
            <input type="checkbox" formControlName="requireLiveness" />
            <span>{{ 'ORG_SETTINGS.FACE_REQUIRE_LIVENESS' | translate }}</span>
          </label>
        </div>
      </fieldset>

      <fieldset class="org-settings__fieldset" [disabled]="!canManage()">
        <legend>{{ 'ORG_SETTINGS.SECTION_ABSENCE_JOB' | translate }}</legend>
        <div class="org-settings__row-inner" formGroupName="absenceJob">
          <label class="field org-settings__check">
            <input type="checkbox" formControlName="enabled" />
            <span class="org-settings__check-copy">
              {{ 'ORG_SETTINGS.ABSENCE_JOB_ENABLED' | translate }}
              <span
                class="field__help"
                tabindex="0"
                [pTooltip]="'ORG_SETTINGS.ABSENCE_JOB_HINT' | translate"
                tooltipPosition="top"
                [attr.aria-label]="'ORG_SETTINGS.ABSENCE_JOB_HINT' | translate"
              >
                <i class="pi pi-info-circle" aria-hidden="true"></i>
              </span>
            </span>
          </label>
        </div>
        <div class="org-settings__row-inner" formGroupName="absenceImpact">
          <label class="field">
            <span class="field__label">
              {{ 'ORG_SETTINGS.ABSENCE_IMPACT_ACTION' | translate }}
              <span
                class="field__help"
                tabindex="0"
                [pTooltip]="'ORG_SETTINGS.ABSENCE_IMPACT_ACTION_HINT' | translate"
                tooltipPosition="top"
                [attr.aria-label]="'ORG_SETTINGS.ABSENCE_IMPACT_ACTION_HINT' | translate"
              >
                <i class="pi pi-info-circle" aria-hidden="true"></i>
              </span>
            </span>
            <select class="field__input" formControlName="action">
              @for (option of absenceImpactActionOptions; track option.value) {
                <option [ngValue]="option.value">{{ numericOptionLabel(option) }}</option>
              }
            </select>
          </label>
          @if (absenceImpactAnnualLeaveSelected()) {
            <label class="field">
              <span class="field__label">
                {{ 'ORG_SETTINGS.ABSENCE_FALLBACK_ACTION' | translate }}
                <span
                  class="field__help"
                  tabindex="0"
                  [pTooltip]="'ORG_SETTINGS.ABSENCE_FALLBACK_ACTION_HINT' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'ORG_SETTINGS.ABSENCE_FALLBACK_ACTION_HINT' | translate"
                >
                  <i class="pi pi-info-circle" aria-hidden="true"></i>
                </span>
              </span>
              <select class="field__input" formControlName="insufficientLeaveFallbackAction">
                @for (option of absenceFallbackActionOptions; track option.value) {
                  <option [ngValue]="option.value">{{ numericOptionLabel(option) }}</option>
                }
              </select>
            </label>
          }
          @if (absenceImpactFallbackInvalid()) {
            <p class="field__error org-settings__field-error" role="alert">{{ 'ORG_SETTINGS.ABSENCE_FALLBACK_REQUIRED' | translate }}</p>
          }
        </div>
      </fieldset>

      <fieldset class="org-settings__fieldset" [disabled]="!canManage()">
        <legend>{{ 'ORG_SETTINGS.SECTION_TRAVEL_MISSION' | translate }}</legend>
        <div class="org-settings__row-inner" formGroupName="travelMission">
          <label class="field org-settings__check">
            <input type="checkbox" formControlName="enabled" />
            <span>{{ 'ORG_SETTINGS.TM_ENABLED' | translate }}</span>
          </label>
          <label class="field org-settings__check" [class.org-settings__check--disabled]="!travelMissionEnabled()">
            <input type="checkbox" formControlName="createOnOffDays" />
            <span>{{ 'ORG_SETTINGS.TM_CREATE_OFF_DAYS' | translate }}</span>
          </label>
          <label class="field org-settings__check" [class.org-settings__check--disabled]="!travelMissionEnabled()">
            <input type="checkbox" formControlName="skipIfAttendanceExists" />
            <span>{{ 'ORG_SETTINGS.TM_SKIP_IF_ATTENDANCE' | translate }}</span>
          </label>
          <label class="field org-settings__check" [class.org-settings__check--disabled]="!travelMissionEnabled()">
            <input type="checkbox" formControlName="useShiftWindow" />
            <span>{{ 'ORG_SETTINGS.TM_USE_SHIFT_WINDOW' | translate }}</span>
          </label>
        </div>
      </fieldset>

      <fieldset class="org-settings__fieldset" [disabled]="!canManage()">
        <legend>{{ 'ORG_SETTINGS.SECTION_HOURLY_PERMISSION' | translate }}</legend>
        <div class="org-settings__row-inner" formGroupName="hourlyLeavePermission">
          <label class="field org-settings__check">
            <input type="checkbox" formControlName="enabled" />
            <span class="org-settings__check-copy">
              {{ 'ORG_SETTINGS.HLP_ENABLED' | translate }}
              <span
                class="field__help"
                tabindex="0"
                [pTooltip]="'ORG_SETTINGS.HLP_HINT' | translate"
                tooltipPosition="top"
                [attr.aria-label]="'ORG_SETTINGS.HLP_HINT' | translate"
              >
                <i class="pi pi-info-circle" aria-hidden="true"></i>
              </span>
            </span>
          </label>
          <label class="field org-settings__check">
            <input type="checkbox" formControlName="requireReason" />
            <span>{{ 'ORG_SETTINGS.HLP_REQUIRE_REASON' | translate }}</span>
          </label>
          <label class="field">
            <span class="field__label">{{ 'ORG_SETTINGS.HLP_MONTHLY_QUOTA' | translate }}</span>
            <input class="field__input" type="number" min="0" step="1" formControlName="monthlyQuotaMinutes" />
          </label>
          <label class="field">
            <span class="field__label">{{ 'ORG_SETTINGS.HLP_MIN_REQUEST' | translate }}</span>
            <input class="field__input" type="number" min="0" step="1" formControlName="minRequestMinutes" />
          </label>
          <label class="field">
            <span class="field__label">{{ 'ORG_SETTINGS.HLP_MAX_REQUEST' | translate }}</span>
            <input class="field__input" type="number" min="0" step="1" formControlName="maxRequestMinutes" />
          </label>
          <label class="field org-settings__check">
            <input type="checkbox" formControlName="allowPastDates" />
            <span>{{ 'ORG_SETTINGS.HLP_ALLOW_PAST' | translate }}</span>
          </label>
          @if (form.controls.attendance.controls.hourlyLeavePermission.controls.allowPastDates.value) {
            <label class="field">
              <span class="field__label">
                {{ 'ORG_SETTINGS.HLP_MAX_PAST_DAYS' | translate }}
                <span
                  class="field__help"
                  tabindex="0"
                  [pTooltip]="'ORG_SETTINGS.HLP_MAX_DAYS_HINT' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'ORG_SETTINGS.HLP_MAX_DAYS_HINT' | translate"
                >
                  <i class="pi pi-info-circle" aria-hidden="true"></i>
                </span>
              </span>
              <input class="field__input" type="number" min="1" step="1" formControlName="maxPastDays" />
              @if (hourlyPermissionDayLimitInvalid('maxPastDays')) {
                <span class="field__error" role="alert">{{ 'ORG_SETTINGS.HLP_MAX_DAYS_INVALID' | translate }}</span>
              }
            </label>
          }
          <label class="field org-settings__check">
            <input type="checkbox" formControlName="allowFutureDates" />
            <span>{{ 'ORG_SETTINGS.HLP_ALLOW_FUTURE' | translate }}</span>
          </label>
          @if (form.controls.attendance.controls.hourlyLeavePermission.controls.allowFutureDates.value) {
            <label class="field">
              <span class="field__label">
                {{ 'ORG_SETTINGS.HLP_MAX_FUTURE_DAYS' | translate }}
                <span
                  class="field__help"
                  tabindex="0"
                  [pTooltip]="'ORG_SETTINGS.HLP_MAX_DAYS_HINT' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'ORG_SETTINGS.HLP_MAX_DAYS_HINT' | translate"
                >
                  <i class="pi pi-info-circle" aria-hidden="true"></i>
                </span>
              </span>
              <input class="field__input" type="number" min="1" step="1" formControlName="maxFutureDays" />
              @if (hourlyPermissionDayLimitInvalid('maxFutureDays')) {
                <span class="field__error" role="alert">{{ 'ORG_SETTINGS.HLP_MAX_DAYS_INVALID' | translate }}</span>
              }
            </label>
          }
        </div>
      </fieldset>
      </div>

      <fieldset class="org-settings__fieldset" [disabled]="!canManage()" formGroupName="payroll">
        <legend>{{ 'ORG_SETTINGS.SECTION_PAYROLL_PERIOD' | translate }}</legend>
        <div class="org-settings__row-inner">
          <label class="field">
            <span class="field__label">
              {{ 'ORG_SETTINGS.PAYROLL_CYCLE_START_DAY' | translate }}
              <span
                class="field__help"
                tabindex="0"
                [pTooltip]="'ORG_SETTINGS.PAYROLL_CYCLE_START_DAY_HINT' | translate"
                tooltipPosition="top"
                [attr.aria-label]="'ORG_SETTINGS.PAYROLL_CYCLE_START_DAY_HINT' | translate"
              >
                <i class="pi pi-info-circle" aria-hidden="true"></i>
              </span>
            </span>
            <input class="field__input" type="number" min="1" max="31" step="1" formControlName="cycleStartDay" />
          </label>
          <label class="field">
            <span class="field__label">
              {{ 'ORG_SETTINGS.PAYROLL_TIME_ZONE' | translate }}
              <span
                class="field__help"
                tabindex="0"
                [pTooltip]="'ORG_SETTINGS.PAYROLL_TIME_ZONE_HINT' | translate"
                tooltipPosition="top"
                [attr.aria-label]="'ORG_SETTINGS.PAYROLL_TIME_ZONE_HINT' | translate"
              >
                <i class="pi pi-info-circle" aria-hidden="true"></i>
              </span>
            </span>
            <select class="field__input" formControlName="timeZoneId">
              @for (option of payrollTimeZoneOptions(); track option.value) {
                <option [value]="option.value">{{ payrollTimeZoneOptionLabel(option) }}</option>
              }
            </select>
          </label>
          <label class="field org-settings__check">
            <input type="checkbox" formControlName="useLastDayFallback" />
            <span>{{ 'ORG_SETTINGS.PAYROLL_LAST_DAY_FALLBACK' | translate }}</span>
          </label>
          <label class="field org-settings__check">
            <input type="checkbox" formControlName="autoGenerateAtPeriodStart" />
            <span>{{ 'ORG_SETTINGS.PAYROLL_AUTO_GENERATE' | translate }}</span>
          </label>
        </div>
      </fieldset>

      <fieldset class="org-settings__fieldset" [disabled]="!canManage()" formGroupName="requests">
        <legend>{{ 'ORG_SETTINGS.SECTION_LEAVE_REQUESTS' | translate }}</legend>
        <div class="org-settings__row-inner" formGroupName="leaveSubmission">
          <label class="field org-settings__check">
            <input type="checkbox" formControlName="allowPastDates" />
            <span>{{ 'ORG_SETTINGS.LEAVE_ALLOW_PAST' | translate }}</span>
          </label>
          @if (form.controls.requests.controls.leaveSubmission.controls.allowPastDates.value) {
            <label class="field">
              <span class="field__label">
                {{ 'ORG_SETTINGS.LEAVE_MAX_PAST_DAYS' | translate }}
                <span
                  class="field__help"
                  tabindex="0"
                  [pTooltip]="'ORG_SETTINGS.LEAVE_MAX_PAST_DAYS_HINT' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'ORG_SETTINGS.LEAVE_MAX_PAST_DAYS_HINT' | translate"
                >
                  <i class="pi pi-info-circle" aria-hidden="true"></i>
                </span>
              </span>
              <input class="field__input" type="number" formControlName="maxPastDays" />
            </label>
          }
        </div>
      </fieldset>

      @if (saveError(); as se) {
        <p class="org-settings__error" role="alert">{{ se }}</p>
      }
      <ng-container *wnIfPermission="orgSettingsManageKeys">
        <div class="org-settings__actions">
          <button type="submit" pButton [disabled]="saving() || form.invalid">
            {{ 'COMMON.SAVE' | translate }}
          </button>
        </div>
      </ng-container>
    </form>

    <app-ai-agents-settings-card />

    <section class="org-settings__subscription" aria-labelledby="org-subscription-heading">
      <div class="org-settings__subscription-heading">
        <div>
          <h2 id="org-subscription-heading">{{ 'ORG_SETTINGS.SUBSCRIPTION_TITLE' | translate }}</h2>
          @if (subscription(); as sub) {
            <p>{{ currentPackageTitle() || ('ORG_SETTINGS.NO_PACKAGE' | translate) }} · {{ 'ENUMS.PLAN.' + sub.plan | translate }}</p>
          }
        </div>
        @if (subscription(); as sub) {
          <strong>{{ formatMoney(sub.totalPrice, sub.currency) }}</strong>
        }
      </div>
      @if (subscription(); as sub) {
        <div class="org-settings__sub-summary">
          <dl class="org-settings__sub-grid">
            <div class="org-settings__sub-item org-settings__sub-item--wide">
              <dt>{{ 'ORG_SETTINGS.CURRENT_PACKAGE' | translate }}</dt>
              <dd>{{ currentPackageTitle() || ('ORG_SETTINGS.NO_PACKAGE' | translate) }}</dd>
            </div>
            <div class="org-settings__sub-item">
              <dt>{{ 'ORG_SETTINGS.PLAN' | translate }}</dt>
              <dd>{{ 'ENUMS.PLAN.' + sub.plan | translate }}</dd>
            </div>
            <div class="org-settings__sub-item">
              <dt>{{ 'ORG_SETTINGS.BILLING_PERIOD' | translate }}</dt>
              <dd>{{ billingPeriodLabel(summaryBillingPeriodMonths(sub)) }}</dd>
            </div>
            <div class="org-settings__sub-item">
              <dt>{{ 'ORG_SETTINGS.CURRENT_USERS' | translate }}</dt>
              <dd>{{ formatNumber(sub.currentUsers) }}</dd>
            </div>
            <div class="org-settings__sub-item">
              <dt>{{ 'ORG_SETTINGS.EMPLOYEE_BAND' | translate }}</dt>
              <dd>{{ summaryPricingBandLabel(sub) }}</dd>
            </div>
            <div class="org-settings__sub-item">
              <dt>{{ 'ORG_SETTINGS.LICENSED_USERS' | translate }}</dt>
              <dd>{{ formatNumber(summaryLicensedUsers(sub)) }}</dd>
            </div>
            <div class="org-settings__sub-item">
              <dt>{{ 'ORG_SETTINGS.BILLABLE_USERS' | translate }}</dt>
              <dd>{{ formatNumber(summaryBillableUsers(sub)) }}</dd>
            </div>
            <div class="org-settings__sub-item">
              <dt>{{ 'ORG_SETTINGS.UNIT_PRICE' | translate }}</dt>
              <dd>{{ formatMoney(sub.unitPrice, sub.currency) }}</dd>
            </div>
            <div class="org-settings__sub-item">
              <dt>{{ 'ORG_SETTINGS.MONTHLY_TOTAL' | translate }}</dt>
              <dd>{{ formatMoney(summaryMonthlyTotal(sub), sub.currency) }}</dd>
            </div>
            <div class="org-settings__sub-item org-settings__sub-item--total">
              <dt>{{ 'ORG_SETTINGS.PERIOD_TOTAL' | translate }}</dt>
              <dd>{{ formatMoney(sub.totalPrice, sub.currency) }}</dd>
            </div>
            <div class="org-settings__sub-item">
              <dt>{{ 'ORG_SETTINGS.PERIOD_END' | translate }}</dt>
              <dd>{{ formatSubscriptionDateTime(sub.periodEndUtc) || ('COMMON.NOT_SET' | translate) }}</dd>
            </div>
            @if (sub.cancelAtPeriodEnd) {
              <div class="org-settings__sub-item org-settings__sub-item--warning">
                <dt>{{ 'ORG_SETTINGS.CANCELLATION' | translate }}</dt>
                <dd><wn-status-chip tone="danger" [label]="'ORG_SETTINGS.CANCELS_AT_PERIOD_END' | translate" /></dd>
              </div>
            }
          </dl>
        </div>
      }

      <p class="org-settings__sub-managed" role="note">
        {{ 'ORG_SETTINGS.SUBSCRIPTION_MANAGED_BY_PROVIDER' | translate }}
      </p>
    </section>
  }
</section>
